<template>
  <b-card class="information" header="data">
    <div slot="header" style="display:flex; justify-content: space-between;">
      <HeaderTitle title="Information"></HeaderTitle>
    </div>
    <div style="min-height: 403px" v-if="!loadingLocation && locationData">
      <span class="title-details">
        Company :
        <b>{{ locationData.company }}</b>
      </span>
      <span class="title-details">
        Location :
        <b>{{ locationData.location }}</b>
      </span>
      <span class="title-details">
        Contact :
        <b>{{ locationData.contact }}</b>
      </span>

      <span class="title-details">
        Address :
        <b>{{ locationData.address1 }}, {{ locationData.clientZip }}</b>
      </span>
      <span class="title-details">
        Phone :
        <b>{{ locationData.clientPhone }}</b>
      </span>
      <span class="title-details">
        Email :
        <b>{{ locationData.clientEmail }}</b>
      </span>

      <gmap-map
        v-if="locationCoords"
        :center="locationCoords"
        :options="mapOptions"
        style="width:100%;  height: 160px;margin-top:25px"
      >
        <gmap-marker :position="locationCoords"></gmap-marker>
      </gmap-map>
    </div>
    <div v-else class="sk-double-bounce">
      <div class="sk-child sk-double-bounce1"></div>
      <div class="sk-child sk-double-bounce2"></div>
    </div>
  </b-card>
</template>

<script>
import router from "../../router";
import { isUserLoggedIn } from "../../utils/Utils";
import HeaderTitle from "../shared/HeaderTitle.vue";

export default {
  name: "LocationInformation",
  props: ["locationCode", "locationCoords"],
  data: function() {
    return {
      locationData: null,
      loadingLocation: false,
      mapOptions: {
        zoom: 7,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        scrollwheel: false,
        draggable: false
      }
    };
  },
  methods: {
    fetchCityData() {
      let params = {
        client: this.locationCode
      };
      this.loadingLocation = true;
      this.$http
        .get("api/profile/clientInfo.php", {
          params
        })
        .then(
          res => {
            this.locationData = res.data;
            this.loadingLocation = false;
          },
          err => {
            this.loadingLocation = false;
            console.log(err);
          }
        );
    }
  },
  mounted() {
    isUserLoggedIn(router);
    if (this.locationCode) this.fetchCityData();
  },
  components: { HeaderTitle }
};
</script>
<style scoped></style>
